import React from "react";
import "./MobileAppComponent.scss"
import img from "../../assets/IMG-473.svg"
import apple from "../../assets/apple.svg"
import playstore from "../../assets/playstore.svg"

const MobileAppComponent = () => {
    return (
        <div className="MobileAppComponent">
            <div className="text-cont-dwn">
                <div className="text-cont-hdr">Download Our Mobile App</div>
                <div className="text-cont-sub">Order faster, track deliveries in real-time, and get exclusive app-only deals and rewards.
                </div>
                <div className="pltform-cont"
                >
                    <div className="plt-cont"><img alt="" src={apple} />
                        <div>
                            <div className="plt-hdr">Download on the</div>
                            <div className="plt-sub-hdr">App Store</div></div></div>

                    <div className="plt-cont"><img alt="" src={playstore} />
                        <div>
                            <div className="plt-hdr">GET IT ON</div>
                            <div className="plt-sub-hdr">Google Play</div></div></div>

                </div>
            </div>
            <div className="downld-ing">
                <img alt="" src={img} />
            </div>
        </div >
    )
}
export default MobileAppComponent